import React from 'react';
import { AnchorLink } from "gatsby-plugin-anchor-links";

export const Header = () => (
  <header className="sticky top-0 bg-white shadow" style={{zIndex:100}}>
    <div className="container flex flex-col sm:flex-row justify-between items-center mx-auto py-4 px-8">
      <div className="flex items-center text-2xl">
        <div className="w-12 mr-3">
          <AnchorLink to="/#top">
            <img alt="Logo" src="../occlogoc.png" />
          </AnchorLink>
        </div>
        Encouraging Faith and Work Engagement In Canada
      </div>
      <div className="flex mt-4 sm:mt-0">
        <AnchorLink className="px-4" to="/#purpose" title="Project" />
        <AnchorLink className="px-4" to="/#stories" title="Stories" />
        <AnchorLink className="px-4" to="/resources" title="Resources" />
        <AnchorLink className="px-4" to="/organizations" title="Directory" />
        <AnchorLink className="px-4" to="/#contact" title="Contact Us" />
      </div>
    </div>
  </header>
);